import { UpdateDocumentTypeComponent } from './update-document-type/update-document-type.component'
import { CreateDocumentTypeComponent } from './create-document-type/create-document-type.component'
import { DocumentTypesComponent } from './document-types.component'
import { MainLayoutComponent } from '@components/main-layout/main-layout.component'
import { Routes } from '@angular/router'
import { AuthGuard } from 'src/app/guards/auth.guard'
import { NgxPermissionsGuard } from 'ngx-permissions'

export const documentTypesRoutes: Routes = [
  {
    path: 'admin/document-types',
    component: MainLayoutComponent,
    canActivate: [AuthGuard, NgxPermissionsGuard],
    data: {
      permissions: {
        only: 'SYSTEM_CONFIGURATION_PANEL',
        redirectTo: '/',
      },
    },
    children: [
      {
        path: '',
        component: DocumentTypesComponent,
        data: {
          permissions: {
            only: 'SYSTEM_CONFIGURATION_PANEL',
            redirectTo: '/',
          },
        },
      },
      {
        path: 'create',
        component: CreateDocumentTypeComponent,
        data: {
          permissions: {
            only: 'SYSTEM_CONFIGURATION_PANEL',
            redirectTo: '/',
          },
        },
      },
      {
        path: ':id/update',
        component: UpdateDocumentTypeComponent,
        data: {
          permissions: {
            only: 'SYSTEM_CONFIGURATION_PANEL',
            redirectTo: '/',
          },
        },
      },
    ],
  },
]
